import { Minus, Plus } from "lucide-react";
import { FAN_FAVOURITE } from "@/data/content";
import { FanBadge } from "./FanBadge";

export const FlavourRow = ({ f, qty, canAdd: roomLeft, soldOut, left, onChange }) => {
  const canAdd = roomLeft && !soldOut;
  return (
  <div data-testid={`builder-flavour-${f.key}`} className={`flex items-center gap-3 rounded-2xl border border-[#1B1530]/10 bg-white p-2.5 sm:p-3 ${soldOut ? "opacity-60" : ""}`} style={{ boxShadow: qty ? `inset 4px 0 0 ${f.color}` : "none" }}>
    <button type="button" data-testid={`builder-add-tap-${f.key}`} onClick={() => canAdd && onChange(1)} disabled={!canAdd} aria-label={`Add ${f.name} to box`}
      className="flex items-center gap-3 min-w-0 flex-1 text-left rounded-xl transition-transform active:scale-[0.98] disabled:cursor-not-allowed">
    <div className="h-12 w-11 shrink-0 rounded-xl grid place-items-center" style={{ background: `${f.color}26` }}>
      <img src={f.img} alt={f.name} className="h-11 w-auto object-contain" />
    </div>
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <p className="font-display text-lg sm:text-xl leading-tight">{f.name}</p>
        {f.key === FAN_FAVOURITE && <FanBadge className="!text-[10px] !px-2 !py-0.5" />}
        {f.isNew && <span className="rounded-full bg-[#FF5A5F] text-white text-[10px] font-bold uppercase px-2 py-0.5">New</span>}
        {soldOut && <span data-testid={`builder-soldout-${f.key}`} className="rounded-full bg-[#1B1530] text-white text-[10px] font-bold uppercase px-2 py-0.5">Sold out</span>}
        {!soldOut && Number.isFinite(left) && left <= 24 && <span data-testid={`builder-left-${f.key}`} className="rounded-full bg-[#FFB21A] text-[#1B1530] text-[10px] font-bold uppercase px-2 py-0.5">Only {left} left</span>}
      </div>
      <p className="text-xs sm:text-sm text-[#4A4560] mt-0.5 truncate">{f.notes}</p>
    </div>
    </button>
    <div className="flex items-center gap-1.5 sm:gap-2 shrink-0">
      <button data-testid={`builder-decrease-${f.key}`} onClick={() => onChange(-1)} disabled={!qty} aria-label={`Remove ${f.name}`}
        className="h-10 w-10 rounded-full border-2 border-[#1B1530]/15 grid place-items-center hover:border-[#1B1530] disabled:opacity-30 transition-colors"><Minus className="h-4 w-4" /></button>
      <span data-testid={`builder-qty-${f.key}`} className="w-7 text-center font-display text-2xl">{qty}</span>
      <button data-testid={`builder-increase-${f.key}`} onClick={() => onChange(1)} disabled={!canAdd} aria-label={`Add ${f.name}`}
        className="h-10 w-10 rounded-full bg-[#1B1530] text-white grid place-items-center hover:bg-[#FF5A5F] disabled:bg-[#1B1530]/20 transition-colors"><Plus className="h-4 w-4" /></button>
    </div>
  </div>
  );
};
